import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'

export default {
  name: 'bag-close-details',
  components: {VueElementLoading},
  props: [],
  data () {
    return {
      isLoading: false,
      listmodal:false,
      isBagNumberError: 0,
      BagNumberError: '',
      bagNumber:'',
      modaldata:'',
      BagDetails:[],
      rowdata:''
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == '' || date == null) {
        return '--'
      }
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
  mounted () {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
  },
  methods: {
    openlistmodal(data,d){
      this.rowdata = d
      this.modaldata = data.ShippingIds
      this.listmodal = true
    },
    closelistmodal(){
      this.listmodal = false
    },
    getBagDetails() {
      if (this.bagNumber == '') {
        this.isBagNumberError = '1',
        this.BagNumberError = 'The Bag Number field is required.'
        return false;
      } else {
        this.isBagNumberError = '',
        this.BagNumberError = ''
      }
      this.isLoading = true
      var self = this
      this.input = ({})
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getBagInShipmentLiveDetailsForCrossBeltSorter/'+ self.bagNumber.trim(),
          'data': this.input,
          headers: {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.BagDetails = result.data.ResponseData
            this.isLoading = false
          } else {
            this.$alertify.error(result.data.ReturnMessage)
            this.isLoading = false
          }
        }, error => {
          console.error(error)
        })
    },
    clearError(){
      if (this.bagNumber == '') {
        this.isBagNumberError = '1',
        this.BagNumberError = 'The Bag Number field is required.'
      } else {
        this.isBagNumberError = '',
        this.BagNumberError = ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/bangloreCBS/BagInShipmentLiveResponse/BagInShipmentLiveResponse.js